<z-segmented [zOptions]="segmentedOptions" [zSize]="zSize" [zVariant]="variant" [zSeverity]="severity"
    [zDisabled]="disabled" [zDefaultValue]="zDefaultValue" (zChange)="onSelectionChange($event)" class="segmented" />
